import React from 'react';

const Pagination = ({ 
  currentPage, 
  totalItems, 
  itemsPerPage, 
  onPageChange,
  position = 'top'
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const renderPagination = () => {
    const pages = [];
    const showPages = 3;

    pages.push(1);

    let startPage = Math.max(2, currentPage - showPages);
    let endPage = Math.min(totalPages - 1, currentPage + showPages);

    if (startPage > 2) {
      pages.push('...');
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    if (endPage < totalPages - 1) {
      pages.push('...');
    }

    if (totalPages > 1) {
      pages.push(totalPages);
    }

    return pages;
  };

  return (
    <nav className={`pagination-nav ${position === 'top' ? 'mb-3' : 'mt-3'}`} aria-label="Pagination">
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
        <ul className="pagination pagination-sm mb-0 flex-wrap">
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
            <button
              type="button"
              className="page-link"
              onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
              disabled={currentPage === 1}
              aria-label="Previous page"
            >
              <span className="d-none d-sm-inline">Previous</span>
              <span className="d-sm-none" aria-hidden="true">‹</span>
            </button>
          </li>
          {renderPagination().map((page, index) => (
            <li
              key={index}
              className={`page-item ${page === currentPage ? 'active' : ''} ${page === '...' ? 'disabled' : ''}`}
            >
              <button
                type="button"
                className="page-link"
                onClick={() => page !== '...' && onPageChange(page)}
                disabled={page === '...'}
                aria-label={page === '...' ? null : `Page ${page}`}
                aria-current={page === currentPage ? 'page' : undefined}
              >
                {page}
              </button>
            </li>
          ))}
          <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
            <button
              type="button"
              className="page-link"
              onClick={() => currentPage < totalPages && onPageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              aria-label="Next page"
            >
              <span className="d-none d-sm-inline">Next</span>
              <span className="d-sm-none" aria-hidden="true">›</span>
            </button>
          </li>
        </ul>
        <div className="text-muted small pagination-total">
          Total: {totalItems} items
        </div>
      </div>
    </nav>
  );
};

export default Pagination; 